import { SVGProps } from 'react';

function DownVoteIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_5151_1492" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
        <rect y="0.4375" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5151_1492)">
        <path d="M5.33333 2.82083V7.4875H3.4C3.11111 7.4875 2.90833 7.6125 2.79167 7.8625C2.675 8.1125 2.70556 8.34861 2.88333 8.57083L7.48333 14.1875C7.61667 14.3542 7.78889 14.4375 8 14.4375C8.21111 14.4375 8.38333 14.3542 8.51667 14.1875L13.1167 8.57083C13.2944 8.34861 13.325 8.1125 13.2083 7.8625C13.0917 7.6125 12.8889 7.4875 12.6 7.4875H10.6667V2.82083C10.6667 2.63194 10.6028 2.47361 10.475 2.34583C10.3472 2.21806 10.1889 2.15417 10 2.15417H6C5.81111 2.15417 5.65278 2.21806 5.525 2.34583C5.39722 2.47361 5.33333 2.63194 5.33333 2.82083Z" fill="currentColor" />
      </g>
    </svg>
  );
}

export default DownVoteIcon;
